import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]
  static values = { maxLines: { type: Number, default: 5 } }

  connect() {
    this.expanded = false
    // Wait for render to measure
    requestAnimationFrame(() => this._checkOverflow())
  }

  toggle(event) {
    event.preventDefault()
    this.expanded = !this.expanded

    if (this.expanded) {
      this.contentTarget.classList.remove("post__body-content--clamped")
      this.contentTarget.style.webkitLineClamp = "unset"
      this.toggleTarget.textContent = this.element.dataset.expandableTextLessLabel || "ver menos"
    } else {
      this.contentTarget.classList.add("post__body-content--clamped")
      this.contentTarget.style.webkitLineClamp = this.maxLinesValue
      this.toggleTarget.textContent = this.element.dataset.expandableTextMoreLabel || "ver mais"
    }
  }

  _checkOverflow() {
    const el = this.contentTarget
    el.style.webkitLineClamp = this.maxLinesValue

    // Compare scroll height vs visible height
    if (el.scrollHeight > el.clientHeight + 2) {
      this.toggleTarget.style.display = ""
    } else {
      this.toggleTarget.style.display = "none"
    }
  }
}
